import { fetchLoggedInUser, fetchEmployeeData } from "services/src/user";
import { login, logout } from "services/src/auth";
import { passwordRequest, passwordReset } from "@directus/sdk";
import { createAsyncThunk } from "@reduxjs/toolkit";
import client from "directus/src/client";


export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ email, password }, { rejectWithValue, dispatch }) => {
    try {
      await login({ email, password });
      const loggedInUser = await fetchLoggedInUser();

      const userBasicInfo = await fetchEmployeeData();

      const user = {
        isAuthenticated: true,
        role: loggedInUser.role,
        userId: loggedInUser.id,
        ...userBasicInfo,
      };

      return user;
    } catch (error) {
      console.log(error.errors[0].message);
      return rejectWithValue(error.errors[0].message);
    }
  },
);

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async ({ email }, { rejectWithValue }) => {
    try {
      const resetUrl = `https://everest.7span.work/reset-password`;
      await client.request(passwordRequest(email, resetUrl));

      return { message: "Password reset email sent successfully" };
    } catch (error) {
      return rejectWithValue(error.message || "Failed to send reset email");
    }
  },
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async ({ token, password }, { rejectWithValue }) => {
    try {
      await client.request(passwordReset(token, password));

      return { message: "Password reset successfully" };
    } catch (error) {
      return rejectWithValue(error.message || "Failed to reset password");
    }
  },
);

export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { rejectWithValue }) => {
    try {
      await logout();
      localStorage.clear();
    } catch (error) {
      console.error("Logout error:", error);
      return rejectWithValue(error.errors[0].message);
    }
  },
);

export const checkAuthStatus = createAsyncThunk(
  "auth/checkStatus",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const loggedInUser = await fetchLoggedInUser();

      const userBasicInfo = await fetchEmployeeData();

      const user = {
        isAuthenticated: true,
        role: loggedInUser.role,
        userId: loggedInUser.id,
        ...userBasicInfo,
      };

      return user;
    } catch (error) {
      return rejectWithValue("Invalid token");
    }
  },
);
